import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchReports = createAsyncThunk(
  "reports/fetchReports",
  async ({ startDate, endDate } = {}, thunkAPI) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const res = await api.get(`/api/reports`, { params });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch reports"
      );
    }
  }
);

const reportSlice = createSlice({
  name: "reports",
  initialState: {
    overallRevenue: 0,
    orders: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearReportsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.loading = false;
        state.overallRevenue = action.payload.overallRevenue;
        state.orders = action.payload.orders;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearReportsError } = reportSlice.actions;
export const selectReports = (state) => state.reports;
export default reportSlice.reducer;